<template>
    <div>
        <div class="Sidebar Sidebar--main">
            <div class="Sidebar__brand">
                <a href="/">
                    <img src="/images/logo.png" alt="SIMI Logo">
                </a>
            </div>
            <div class="Sidebar__menu">
                <nav>
                    <ul class="Utility__list-unstyled">
                        <li :class="'Sidebar__menu-item Sidebar__menu-item--'+page.class" v-for="page in mainItems">
                            <a :href="page.url" v-html="page.name"></a>
                        </li>

                        <li class="Sidebar__menu-item" v-if="requiresOverflow">
                            <a href="#" :class="overflowTogglerClasses" @click.prevent="toggleOverflow()">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 50 30"
                                     id="icon-navigation-more"
                                     width="100%"
                                     height="100%"
                                     class="Sidebar__menu-icon"
                                >
                                    <path d="M12.1 10.9c-3.3 0-4.1.9-4.1 4.1s.8 4.1 4.1 4.1 4.1-.8 4.1-4.1-.8-4.1-4.1-4.1zM25 10.9c-3.3 0-4.1.8-4.1 4.1s.8 4.1 4.1 4.1 4.1-.8 4.1-4.1-.8-4.1-4.1-4.1zM37.9 10.9c-3.3 0-4.1.8-4.1 4.1s.8 4.1 4.1 4.1S42 18.3 42 15s-.8-4.1-4.1-4.1z"></path>
                                </svg>
                                <div class="Sidebar__menu-label">More</div>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div :class="overflowClasses" v-if="requiresOverflow">
            <ul class="Sidebar__menu Utility__list-unstyled">
                <li :class="'Sidebar__menu-item Sidebar__menu-item--overflow Sidebar__menu-item--'+item.class"
                    v-for="item in overflowItems"
                >
                    <a :href="item.url">
                        {{ overflowName(item.name) }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showOverflow: false,
                menuHeight: 0,

                offsets: null,
            }
        },

        props: {
            items: {
                type: Array,
                required: true,
            },

            displayThreshold: {
                type: Number,
                default: 7
            },
        },

        mounted() {
            this.setMenuHeight();

            window.addEventListener('resize', e => {
                this.setMenuHeight();

                this.$forceUpdate();
            });

            let imagesLoaded = require('imagesloaded');

            let imgLoad = imagesLoaded( '.Sidebar--main');

            imgLoad.on('always', () => {
                this.setOffsets();
            });
        },

        computed: {
            requiresOverflow() {
                return ! this.offsets || this.items.length > this.displayThreshold || this.items.length > this.mainItems.length;
            },

            adjustedLink() {
                let link = this.activeLink.split('/');

                return '/' + link.slice(0, 2).join('/');
            },

            classes() {
                return {
                    'Sidebar NavBar--main': true,
                    'Sidebar--no-shadow': this.noShadow,
                    'Sidebar--no-overflow': ! this.requiresOverflow,
                }
            },

            overflowClasses() {
                return {
                    'Sidebar__overflow': true,
                    'Sidebar__overflow--open': this.showOverflow,
                    'Sidebar__overflow--no-shadow': this.noShadow,
                }
            },

            overflowTogglerClasses() {
                return {
                    'Sidebar__menu-item': true,
                    'Sidebar__menu-item--overflow-active': this.showOverflow,
                }
            },

            mainItems() {
                let count = this.offsets ? Math.min(this.displayThreshold, this.displayCount) : this.displayThreshold;

                return this.items.slice(0, count);
            },

            displayCount() {
                let count = _.filter(this.offsets, offset => {
                    return offset <= this.menuHeight;
                }).length - 1;

                return Math.max(0, count);
            },

            overflowItems() {
                let count = this.offsets ? Math.min(this.displayThreshold, this.displayCount) : this.displayThreshold;

                return this.items.slice(count);
            }
        },

        methods: {
            toggleOverflow() {
                this.showOverflow = ! this.showOverflow;
            },

            itemClasses(item) {
                return {
                    'Sidebar__menu-item': true,
                    'Sidebar__menu-item--active': item.url === this.adjustedLink,
                }
            },

            /**
             * Set the actual height of the menu
             */
            setMenuHeight() {
                this.menuHeight = this.$el.querySelector('.Sidebar').offsetHeight;
            },

            setOffsets() {
                let offsets = [200];

                _.forEach(this.$el.querySelectorAll('.Sidebar__menu-item'), (item, index) => {
                    offsets.push(item.offsetHeight + offsets[index]);
                });

                offsets.pop();

                this.offsets = offsets;
            },

            overflowName(name) {
                return name.replace(/(<([^>]+)>)/ig," ");
            }
        }
    }
</script>
